var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgResponseRate = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 39 39",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M19.2 14.564a5.24 5.24 0 0 0-5.236 5.236.583.583 0 0 1-1.164 0 6.407 6.407 0 0 1 9.122-5.794.582.582 0 1 1-.495 1.053 5.2 5.2 0 0 0-2.227-.495"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  transform: "translate(17.067 16.6)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.133,
  cy: 5.333,
  r: 2.133
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.133,
  height: 5.333,
  x: 1.067,
  rx: 1.067
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2.133,
  d: "M19.2 11.267a8.5 8.5 0 0 0-6.03 2.502 8.5 8.5 0 0 0-2.504 6.031c0 2.353.957 4.486 2.502 6.03a8.5 8.5 0 0 0 6.031 2.503 8.5 8.5 0 0 0 6.03-2.502 8.5 8.5 0 0 0 2.503-6.031 8.5 8.5 0 0 0-2.502-6.03 8.5 8.5 0 0 0-6.031-2.503z"
}))));
export default SvgResponseRate;